import { styled } from '@uhg-abyss/web/tools/styled';

const CardTitleStyle = styled('div', {
  backgroundColor: '$gray4',
  padding: '0.7rem 0.5625rem 0.7rem 0.825rem',
  borderRadius: '0.1875rem 0.1875rem 0 0',
  color: '$gray8',
  fontWeight: 'bold',
  fontSize: '20px',
  lineHeight: '20px',
});

export const CardTitle = CardTitleStyle;
